import React, { useEffect, useState } from 'react'
import { Col, Row, Image } from 'react-bootstrap'
import imgSKY from '../../../images/SKY.png'
import imgMettheir from '../../../images/MT.jpg'
import imgAstro from '../../../images/ASTRO.png'
import imgProInside from '../../../images/ProInside.png'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { getContractDetailAPI } from '../../../services/contract'
import ContractPDPANav from './contract-nav-pdpa'
import Error_500 from '../../error/error-500'

export default function PDPAPreview() {
  const [data, setData] = useState([])
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const [signatureEMP, setSignatureEMP] = useState([])
  const idCard = searchParams.get('idCard')
  const phone = searchParams.get('phone')
  const orgId = searchParams.get('orgId')

  const [isConfirm2, setIsConfirm2] = useState()
  const [isConfirm3, setIsConfirm3] = useState()
  const [isConfirm4, setIsConfirm4] = useState()
  const [signaturePD, setSignaturePD] = useState([])
  const [isCheck4, setIsCheck4] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    moment.locale('th')
    getContractDetail()
  }, [orgId, idCard, phone])

  const getContractDetail = async () => {
    try {
      setIsLoading(true)

      const param = {
        orgId,
        idCard,
        phone
      }
      const result = await getContractDetailAPI(param)
      setIsLoading(false)
      if (!result) return
      if (result.status) {
        setData(result.result)
        setIsConfirm2(result.result.signatures_pd[1].pd2.is_confirm)
        setIsConfirm3(result.result.signatures_pd[2].pd3.is_confirm)
        setIsConfirm4(result.result.signatures_pd[3].pd4.is_confirm)
        setSignaturePD(result.result.signatures_pd[3].pd4)
        setIsCheck4(result.result.signatures_pd[3].pd4.is_confirm)
        setSignatureEMP(result.result.signatures[5].employee)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const checkLink = () => {
    switch (data?.org_id) {
      case 2:
        return 'https://www.metthier.co.th/en/privacy-policy'

      case 5:
        return 'https://www.proinside.co.th/th/privacy-policy/'

      default:
        return 'https://www.skyict.co.th/privacy-policy'
    }
  }
  return (
    <>
      {isLoading && <div className="preloader"></div>}

      <ContractPDPANav
        data={data}
        isCheck4={isCheck4}
        signatureEMP={signatureEMP}
        getContractDetail={getContractDetail}
      />
      <Row>
        <Col xl={12}>
          <div
            className="p-2 m-2"
            style={{
              lineHeight: 2
            }}
          >
            <div
              className="d-flex justify-content-start"
              style={{
                height: 80
              }}
            >
              {data?.org_id === 1 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 100,
                    height: 50
                  }}
                  src={imgSKY}
                />
              ) : data?.org_id === 2 ? (
                <Image
                  className="mt-2"
                  style={{
                    width: 100,
                    height: 80
                  }}
                  src={imgMettheir}
                />
              ) : data?.org_id === 3 ? (
                <Image
                  className="mb-1"
                  style={{
                    width: 90,
                    height: 80
                  }}
                  src={imgAstro}
                />
              ) : data?.org_id === 5 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 110,
                    height: 55
                  }}
                  src={imgProInside}
                />
              ) : null}
            </div>

            <div className="text-center fw-normal mb-2 fs-5 mt-0 ">
              แบบฟอร์มขอความยินยอมในการประมวลผลข้อมูลส่วนบุคคล
            </div>
            <p className="fw-normal mb-0 text-center mb-5">
              (ข้อมูลตามมาตรา 26)
            </p>
            <p className="fw-light small">
              &nbsp;&nbsp;&nbsp;&nbsp;
              ด้วยความเคารพต่อสิทธิในข้อมูลส่วนบุคคลของพนักงานอย่างสูงสุดและเพื่อให้ความคุ้มครองสิทธิของพนักงานเป็นไปอย่างถูกต้องเหมาะสมตามกฎหมาย
              ทางบริษัทขอความกรุณาขอความยินยอมจากท่านเพื่ออนุญาตให้ทางบริษัทประมวลผลข้อมูลเพื่อวัตถุประสงค์ต่อไปนี้
            </p>
            <p className="fw-light small">
              1. ในการบันทึกเวลาเข้าออกงาน
              ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ใบหน้า)
              เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลสถิติการเข้าออกงาน
              (SPD37: การบันทึกเวลาเข้าออกงาน)
            </p>

            <p className="fw-light small">
              2. ในการบันทึกเวลาเข้าออกงาน
              ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ลายนิ้วมือ)
              เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลสถิติการเข้าออกงาน
              (SPD37: การบันทึกเวลาเข้าออกงาน){' '}
            </p>

            <p className="fw-light small">
              3. ในการผ่านเข้าออกพิ้นที่
              ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ใบหน้า)
              เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลการเข้าออกพื้นที่
              (SPD39: การเข้าออกพื้นที่){' '}
            </p>

            <p className="fw-light small">
              4. ในการผ่านเข้าออกพิ้นที่
              ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ลายนิ้วมือ)
              เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลการเข้าออกพื้นที่
              (SPD39: การเข้าออกพื้นที่){' '}
            </p>

            <p className="fw-light small">
              &nbsp;&nbsp;&nbsp;&nbsp;
              โปรดทำความเข้าใจว่าการไม่ยินยอมให้ทางบริษัทประมวลผลข้อมูลดังกล่าวไม่มีผลต่อสัญญาหลักแต่ประการใด
              ทางบริษัทจะดูแลรักษาข้อมูลของท่านด้วยความปลอดภัยขั้นสูงสุด
              และจะประมวลผลรักษาข้อมูลของท่านไว้ตามระยะเวลา ที่กำหนด
              และจะทำการลบข้อมูลทันทีหลังจากนั้น
              โดยท่านสามารถอ่านรายละเอียดเพิ่มเติมได้ที่
              “นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับบุคลากรและผู้สมัครงาน” หรือ บน
              website{' '}
              <a href={checkLink()} target="blank">
                {checkLink()}
              </a>
            </p>

            <p className="fw-light small">
              &nbsp;&nbsp;&nbsp;&nbsp; ทางบริษัทยังยินดีที่จะเรียนให้ท่านทราบว่า
              ความยินยอมดังกล่าวนี้สามารถเพิกถอนได้ทุกเมื่อ ทางบริษัทมีระบบ
              ที่พร้อมจะดำเนินการลบข้อมูลที่ท่านได้ให้ไว้เพื่ออำนวยความสะดวกให้แก่ท่าน
              โดยท่านเพียงแจ้งความจำนงค์มาที่ DPO@skyict.co.th
              นอกจากนี้เมื่อไรก็ตามที่ทางบริษัทจะมีการเปลี่ยนแปลงหรือเพิ่มเติมวัตถุประสงค์ใด
              ๆ ทางบริษัทจะแจ้งให้ท่านทราบ
              และขอความยินยอมจากท่านเป็นรายกรณีก่อนเสมอ
            </p>

            <p className="fw-light small">
              ข้าพเจ้ารับทราบข้อมูลดังกล่าวและลงชื่อเพื่อยืนยันการแสดงความยินยอมตามที่ได้เลือกไว้
            </p>

            {isConfirm2 === 1 && isConfirm3 === 1 && isConfirm4 === 1 ? (
              <div
                className="border-2 p-5 mt-5 card d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: '5px',
                  border: 'dotted',
                  maxHeight: '300px'
                }}
              >
                {signaturePD && (
                  <div className="col-6">
                    <p className="fw-light text-center small mt-4 ">
                      <span className="m-0 p-0 d-flex justify-content-center">
                        <Image
                          src={signaturePD?.url || null}
                          style={{
                            width: '150px',
                            marginBottom: -25
                          }}
                        ></Image>
                      </span>
                      ลงชื่อ........................................................................
                      ผู้ดำเนินการ
                    </p>
                    <p className="fw-light text-center small mt-0">
                      ( {signaturePD?.title_th || '-'}
                      {signaturePD?.name_th || '-'}{' '}
                      {signaturePD?.surname_th || '-'} )
                    </p>
                    <p className="fw-light text-center small mt-0 ">
                      {signaturePD?.position_th || '-'}
                    </p>
                    <p className="fw-light text-center small mt-0">
                      วันที่{' '}
                      {signaturePD?.confirm_date_pd
                        ? moment(signaturePD?.confirm_date_pd)
                            .add(543, 'year')
                            .format('D MMMM YYYY HH:mm')
                        : '-'}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}
